import LockOutlined from "@mui/icons-material/LockOutlined";

import Button, { ButtonTypes } from "../Button";
import { LockLine } from "./styles";
import { ExpenseCashbackLockProps } from "./types";

export const ExpenseCashbackLock = ({ onOpen }: ExpenseCashbackLockProps) => (
  <LockLine title="Edit the expense to change this cashback">
    <LockOutlined aria-hidden />
    <span>Managed by an expense</span>
    {onOpen && (
      <>
        <span aria-hidden>·</span>
        <Button
          type={ButtonTypes.link}
          size="small"
          onClick={onOpen}
          aria-label="Open the expense"
        >
          Open
        </Button>
      </>
    )}
  </LockLine>
);
